import React from 'react';
import {
  SelectFieldV2,
} from 'ui/FormElement';

import { useFormikContext } from 'formik';

import useEnterpriseTeams from 'components/Common/EnterpriseTeams/Hooks/useEnterpriseTeams';

export default function EnterpriseTeam() {
  const {
    values: { enterprise },
  } = useFormikContext();

  const teams = enterprise ? useEnterpriseTeams({ enterpriseId: enterprise }) : null;

  let placeholder = 'Choose Enterprise first';

  if (enterprise !== null) {
    placeholder = teams == null
      ? 'Enterprise Team is loading ...'
      : 'Choose Enterprise Team...';
  }

  return (

    <SelectFieldV2
      name="enterprise_teams"
      label={(
        <span>Enterprise Team</span>
            )}
      placeholder={placeholder}
      options={teams == null ? [] : teams.map((item) => ({
        label: item.attributes.title,
        value: item.id,
      }))}
      isMulti
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        control: (provided) => ({
          ...provided,
          maxHeight: '100px', // Adjust the maxHeight as needed
          minHeight: '100px', // Adjust the minHeight as needed
          overflowY: 'auto',
        }),
        multiValue: (provided) => ({
          ...provided,
          whiteSpace: 'nowrap', // Prevent the component from growing vertically
        }),
      }}
      menuPortalTarget={document.body}
    />
  );
}
